import { entriesInternal, cachedEntries, getCachedKeys } from "./local-storage";
import { getFlightDetails as getEventingFlightDetails } from "../../ShellCommon/eventModule/window-communication-bridge-flighting";
import { HeuristicallyGeneratedLocalStorageKeyMap } from "./heuristically-generated-local-storage-key-map";
import {
  getInstance as WindowHeartbeatInstance,
  WindowHeartbeatService
} from "../../ShellCommon/eventModule/window-heartbeat-service";

/**
 * Work around to get all localstorage entries caused by issue 11068047
 * Causes a memory leak in edge.
 * @param localStorage window.localstorage
 */
export function memoryLeakEntries(): Map<string, string> {
  return entriesInternal(window.localStorage);
}

/** calls a wrapper around localstorage. */
export function entries(storage: any): Map<string, string> {
  return StorageWrapperService.getInstance().entries();
}

/** calls a wrapper around locatstorage. */
export function getKeys(storage: any, checkExists?: boolean): Set<string> {
  return StorageWrapperService.getInstance().getKeys(checkExists);
}

export const storagePrefix = "sdls";
let instance: StorageWrapperService;

export class StorageWrapperService implements Storage {
  [index: number]: string;
  [key: string]: any;
  keyMap = new Map<string, string>();
  hbService: WindowHeartbeatService;
  isEnabled = false;
  private enabledHeuristicPromise: Promise<any>;
  private constructor() {
    this.hbService = WindowHeartbeatInstance();
    this.enabledHeuristicPromise = new Promise<any>((resolve, reject) => {
      getEventingFlightDetails().then((flightDetails) => {
        this.isEnabled = flightDetails.useLocalStorageWrapper;
        if (this.isEnabled) {
          resolve();
        } else {
          reject("flight off");
        }
      });
    }).catch(() => {});
  }

  public static getInstance() {
    if (!instance) {
      instance = new StorageWrapperService();
    }
    return instance;
  }

  public get length(): number {
    throw new Error("length() Not supported");
  }

  public clear() {
    throw new Error("clear() Not supported");
  }

  public getItem(key: string) {
    return window.localStorage.getItem(key);
  }

  public key(index: number): string {
    return window.localStorage.key(index);
  }

  public getKeys(checkExists?: boolean): Set<string> {
    return getCachedKeys(window.localStorage, checkExists);
    // Heuristics based keys are not enabled as its currently disabled
    // when its enabled it has to be coded for.
  }

  public entries(): Map<string, string> {
    if (!this.isEnabled) {
      return cachedEntries(window.localStorage);
    }
    let entryMap = new Map<string, string>();
    this.hbService.getWindows().forEach((window) => {
      let map = new HeuristicallyGeneratedLocalStorageKeyMap(`${storagePrefix}_${window.windowId}`, 1000);
      map.entries().forEach((value, key) => {
        entryMap.set(key, value);
      });
    });

    return entryMap;
  }

  public removeItem(keyToRemove: string) {
    localStorage.removeItem(keyToRemove);
  }

  public setItem(key: string, value: string): any {
    localStorage.setItem(key, value);
    return this.enabledHeuristicPromise
      .then(() => {
        let map = new HeuristicallyGeneratedLocalStorageKeyMap(
          `${storagePrefix}_${this.hbService.getCurrentWindowId()}`,
          1000
        );
        map.trackKey(key);
      })
      .catch(() => {});
  }
}
